import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'tiyenyen_bites';

function loadAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function saveAll(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function useBiteLog(dateKey) {
  const [allBites, setAllBites] = useState(loadAll);

  useEffect(() => {
    saveAll(allBites);
  }, [allBites]);

  const bites = allBites[dateKey] || [];

  const addBite = useCallback(
    ({ lat, lng, city, country, countryCode, ip }) => {
      const bite = {
        id: Date.now(),
        timestamp: new Date().toISOString(),
        ip: ip || null,
        lat,
        lng,
        city,
        country,
        countryCode,
      };
      setAllBites((prev) => ({
        ...prev,
        [dateKey]: [...(prev[dateKey] || []), bite],
      }));
    },
    [dateKey]
  );

  const removeBite = useCallback(
    (id) => {
      setAllBites((prev) => ({
        ...prev,
        [dateKey]: (prev[dateKey] || []).filter((b) => b.id !== id),
      }));
    },
    [dateKey]
  );

  const daysWithBites = Object.keys(allBites).filter(
    (k) => allBites[k] && allBites[k].length > 0
  );

  return { bites, addBite, removeBite, daysWithBites };
}
